import "../css/About.css";

const About = () => {
  return (
    <main className="about">

      {/* HERO */}
      <section className="about-hero">
        <div className="about-hero-overlay" />
        <div className="about-hero-content">
          <h1>
            About<br />
            Neo Café
          </h1>
          <p>
            A café shaped by time, intention,
            and the simple joy of good coffee.
          </p>
        </div>
      </section>

      {/* INTRO TEXT */}
      <section className="about-intro">
        <p>
          Neo Café was created as a response to fast lives
          and rushed mornings.
        </p>
        <p>
          We wanted to build a place where people slow down,
          sit longer, and feel at ease.
        </p>
      </section>

      {/* IMAGE + STORY */}
      <section className="about-story">
        <div
          className="about-image"
          style={{
            backgroundImage:
              "url(https://images.pexels.com/photos/2074130/pexels-photo-2074130.jpeg)",
          }}
        />
        <div className="about-text">
          <h2>How It Started</h2>
          <p>
            What began as a small idea quickly became a space
            for people who love coffee as much as conversation.
          </p>
          <p>
            Every decision — from lighting to beans —
            was made to create warmth, calm, and comfort.
          </p>
        </div>
      </section>

      {/* BIG STATEMENT */}
      <section className="about-statement">
        <h2>
          Coffee is not the product.<br />
          The experience is.
        </h2>
      </section>

      {/* VALUES */}
      <section className="about-values">
        <div>
          <h3>Slow Coffee</h3>
          <p>Crafted with patience, never rushed.</p>
        </div>
        <div>
          <h3>Warm Spaces</h3>
          <p>Designed for people, not just seats.</p>
        </div>
        <div>
          <h3>Human Moments</h3>
          <p>Conversations that stay longer than cups.</p>
        </div>
      </section>

      {/* FULL IMAGE */}
      <section
        className="about-full"
        style={{
          backgroundImage:
            "url(https://images.pexels.com/photos/373639/pexels-photo-373639.jpeg)",
        }}
      >
        <p>
          Built for mornings.<br />
          Loved through evenings.
        </p>
      </section>

      {/* FINAL NOTE */}
      <section className="about-final">
        <h2>
          Neo Café is not just a café.<br />
          It’s a place to belong.
        </h2>
      </section>

    </main>
  );
};

export default About;
